import { render, staticRenderFns } from "./BusDataSyncUopDocMainSetModal.vue?vue&type=template&id=1dd2092b&scoped=true&"
import script from "./BusDataSyncUopDocMainSetModal.vue?vue&type=script&lang=js&"
export * from "./BusDataSyncUopDocMainSetModal.vue?vue&type=script&lang=js&"
import style1 from "./BusDataSyncUopDocMainSetModal.vue?vue&type=style&index=1&id=1dd2092b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd2092b",
  null
  
)

export default component.exports